export type CompetencyType = {
  actual_completion_date: string;
  created: string;
  description: string;
  graphics: {
    iconbg: string;
    bordercolor: string;
    icon: string;
    iconshadow: string;
    imgurl: string;
  };
  semester_detail: {
    semester_name: string;
    course_url: string;
    instructors: string;
    start_date: any;
    end_date: any;
    assessment_only: boolean;
    is_attendance_required: boolean;
  };
  instructors: string;
  prerequisites: Array<any>;
  area_map: {
    core_technical: boolean;
    math_science: boolean;
    research: boolean;
    social_communication_arts: boolean;
    soft_skill: boolean;
    xp: boolean;
  };
  skills: Array<any>;
  credits: string;
  competency_code: string;
  display_version: string;
  curriculum_version: number | string;
  version_status: string;
  id: string;
  required: boolean;
  start_date: any;
  status: string;
  status_val: number;
  target_completion_date: string;
  title: string;
  subdomain_title: string;
  pillar_title: string;
};
export const EmptyCompetencyType = {
  actual_completion_date: "",
  created: "",
  description: "",
  curriculum_version: "",
  display_version: "",
  version_status: "",
  graphics: {
    iconbg: "",
    bordercolor: "",
    icon: "",
    iconshadow: "",
    imgurl: "",
  },
  instructors: "",
  prerequisites: [],
  area_map: {
    core_technical: false,
    math_science: false,
    research: false,
    social_communication_arts: false,
    soft_skill: false,
    xp: false,
  },
  semester_detail: {
    semester_name: "",
    course_url: "",
    instructors: "",
    start_date: "",
    end_date: "",
    assessment_only: false,
    is_attendance_required: false
  },
  skills: [],
  credits: "",
  competency_code: "",
  id: "",
  required: false,
  start_date: "",
  status: "",
  status_val: 0,
  target_completion_date: "",
  subdomain_title: "",
  pillar_title: "",
  title: "",
};
export type MilestoneType = {
  assessment_only: boolean;
  actual_completion_date: string;
  competency_card: CompetencyType;
  created: string;
  description: string;
  graphics: {
    iconbg: string;
    bordercolor: string;
    icon: string;
    iconshadow: string;
    imgurl: string;
  };
  semester_detail: {
    start_date: string;
    end_date: string;
    semester_name: string;
    start_time: string;
    end_time: string;
    location: string;
    instructors: string;
    weekday: string;
  };
  id: string;
  required: boolean;
  start_date: any;
  status: string;
  status_val: number;
  target_completion_date: string;
  title: string;
};
export const EmptyMilestoneType = {
  assessment_only: false,
  actual_completion_date: "",
  competency_card: EmptyCompetencyType,
  created: "",
  description: "",
  graphics: {
    iconbg: "",
    bordercolor: "",
    icon: "",
    iconshadow: "",
    imgurl: "",
  },
  semester_detail: {
    start_date: "",
    end_date: "",
    semester_name: "",
    start_time: "",
    end_time: "",
    location: "",
    instructors: "",
    weekday: "",
  },
  id: "",
  required: false,
  start_date: "",
  status: "",
  status_val: 0,
  target_completion_date: "",
  title: "",
};